import React from 'react';
import { Icon, IconProps } from 'semantic-ui-react';
import { DownOutlined } from 'src/components/icons';

export type SelfProps = {
  text?: React.ReactNode;
  className?: string;
};

export type Props = {
  title?: SelfProps;
  content?: SelfProps;
  itemKey?: React.Key;
  isActive?: boolean;
  className?: string;
  icon?: IconProps | null;
  border?: boolean;
  onTitleClick?: (key: React.Key) => void;
};

const AccordionItem: React.FC<Props> = (props) => {
  const {
    title = {},
    content = {},
    className = '',
    icon = {},
    isActive,
    border,
    itemKey,
    onTitleClick,
  } = props;

  const getItemCls = () => {
    const activeCls = isActive ? 'active' : '';
    const borderCls = border ? 'border' : '';
    const itemCls = className || '';

    return `custom_accordion_item ${[itemCls, borderCls, activeCls]
      .filter(Boolean)
      .join(' ')}`;
  };

  return (
    <div className={getItemCls()}>
      <div
        className={`custom_accordion_item_title ${title.className || ''}`}
        onClick={() => onTitleClick?.(itemKey!)}
      >
        <span>{title.text}</span>
        {icon !== null && (
          <Icon as={icon.as || DownOutlined} name={icon.name} />
        )}
      </div>
      <div className="custom_accordion_item_inner">
        <div className="custom_accordion_item_content">
          <div className="custom_accordion_item_paragraph">{content.text}</div>
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
